
import React from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useSettings } from "@/context/SettingsContext";
import { getRpgThemeClasses, getRpgTerminology } from "@/lib/utils";
import { Scroll, Plus } from "lucide-react";
import { JournalEntry } from "@/hooks/journal/types";
import ExportButton from "@/components/export/ExportButton";

interface HistoryHeaderProps {
  onCreateNew: () => void;
  journalEntries?: JournalEntry[]; // Add entries for bulk export
}

const HistoryHeader: React.FC<HistoryHeaderProps> = ({ 
  onCreateNew, 
  journalEntries = [] 
}) => {
  const { darkMode, enableRpgMode } = useSettings();
  const rpgTheme = getRpgThemeClasses(enableRpgMode, darkMode);

  return (
    <div className="flex justify-between items-center mb-6">
      <h1 className={cn(
        "text-2xl font-semibold",
        enableRpgMode ? (
          rpgTheme.text + " font-bold drop-shadow-md"
        ) : (
          darkMode ? "text-[#FBF3F1]" : "text-[#1E0C46]"
        )
      )}>
        {enableRpgMode ? getRpgTerminology("Journal History") : "Journal History"}
      </h1>
      
      <div className="flex gap-2">
        {/* Add bulk export button */}
        {journalEntries.length > 0 && (
          <ExportButton
            entries={journalEntries}
            variant="outline"
            defaultFormat="pdf"
            allowDateFilter={true}
            className={cn(
              enableRpgMode ? rpgTheme.button : (
                darkMode ? "bg-[#6127A0]/20 hover:bg-[#6127A0]/30" : "bg-[#6127A0]/10 hover:bg-[#6127A0]/20"
              )
            )}
          />
        )}

        <Button 
          onClick={onCreateNew}
          className={cn(
            enableRpgMode ? rpgTheme.button : (
              darkMode ? "bg-[#6127A0] hover:bg-[#4d1f80]" : "bg-[#6127A0] hover:bg-[#4d1f80]"
            )
          )}
        >
          {enableRpgMode ? (
            <>
              <Scroll className="mr-2 h-4 w-4" />
              {getRpgTerminology("New Entry")}
            </>
          ) : (
            <>
              <Plus className="mr-2 h-4 w-4" />
              New Entry
            </>
          )}
        </Button>
      </div>
    </div>
  );
};

export default HistoryHeader;
